import { render, staticRenderFns } from "./OnboardingElectronicAddressPage.vue?vue&type=template&id=aa9fd7aa&scoped=true&"
import script from "./OnboardingElectronicAddressPage.vue?vue&type=script&lang=js&"
export * from "./OnboardingElectronicAddressPage.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingElectronicAddressPage.vue?vue&type=style&index=0&id=aa9fd7aa&prod&lang=scss&"
import style1 from "./OnboardingElectronicAddressPage.vue?vue&type=style&index=1&id=aa9fd7aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9fd7aa",
  null
  
)

export default component.exports